<template>
  <div class="video-message">
    视频消息
  </div>
</template>

<script>
export default {
  name: 'VideoMessage',
  components: {},
  data() {
    return {}
  },
  methods: {},
  created() {},
}
</script>
<style lang="less" scoped></style>
